import React from 'react'

import { getJsonQueryParam } from '../../../packages/kiti/utils/helpers/url'
import { useCheckinService } from './ServiceContext'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import Button from '../../../packages/kiti/components/actions/Button'

const CloseButton = () => {
  const navigate = useNavigation()
  const service = useCheckinService()
  const { origin } = getJsonQueryParam('state') || {}

  if (!!origin) {
    return (
      <Button
        onClick={() => {
          window.location.replace(origin)
        }}
      >
        Voltar para as integrações
      </Button>
    )
  }

  return <Button onClick={() => window.close()}>Fechar aba de integração</Button>
}

export default CloseButton
